import React, { useCallback, useMemo } from "react";
import { useImagePreviewContext } from "./ImagePreviewContext";
import { useComponentEditorContext } from "./ComponentEditorContext";
import { Box, FormControl, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { useTreeModifyContext } from "./TreeDataContext";
import { usePathContext } from "./PathInfo";

export function ImagePreview(props: { value: string; propName: string }) {
  const { setSelectedImage } = useImagePreviewContext();
  const { getVisual, allImages } = useComponentEditorContext();
  const { saveChangesAtPath } = useTreeModifyContext();
  const { path } = usePathContext();

  const handleImageClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      setSelectedImage(props.value);
    },
    [props.value, setSelectedImage],
  );

  const visual = useMemo(() => {
    function getStyle() {
      return {
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      };
    }

    return getVisual(
      { type: "src", value: props.value },
      () => {},
      getStyle(),
      { minWidth: "8rem", minHeight: "8rem", maxWidth: "12rem", maxHeight: "12rem", objectFit: "contain" },
      "image-hover",
      handleImageClick,
    );
  }, [props.value, getVisual, handleImageClick]);

  const saveImageChanged = useCallback(
    (event: SelectChangeEvent) => {
      saveChangesAtPath(event.target.value, path);
    },
    [path, saveChangesAtPath],
  );

  const menuItems = useMemo(
    () =>
      Object.entries(allImages).map(([key, imageInfo]) => (
        <MenuItem key={key} value={key}>
          {key}
        </MenuItem>
      )),
    [allImages],
  );

  return (
    <FormControl>
      <Box className="horizontal-flex flex-wrap">
        <Typography component={"span"}>{props.propName}: </Typography>
        <Box className="horizontal-flex flex-wrap">
          <Select labelId="image-target-label" id="image-target" value={props.value} onChange={saveImageChanged}>
            {menuItems}
          </Select>
          {visual}
        </Box>
      </Box>
    </FormControl>
  );
}
